import * as React from "react";
import { FormControl } from "@mui/joy";
import { Avatar } from "primereact/avatar";
import { s3GetUrl, s3UploadFile, s3UploadFileImage } from "../service/s3Service";
import { PencilEdit } from "../assets/icons";
import { placeholder } from "../assets/placeholder";
import { useEffect } from "react";

export default function ImageS3Upload(props: {
  photo?: string;
  setPhoto?:
    | React.Dispatch<string>
    | ((value: string | ((prevState: string) => string)) => void)
    | undefined;
  s3Key?: string;
  setS3Key?: React.Dispatch<string>;
  file?: File;
  setFile?: React.Dispatch<File>;
  toast?: any;
  toastMessage?: string;
  disabled?: boolean;
  setImageUrl?: React.Dispatch<React.SetStateAction<string>>;
}) {
  let {
    file,
    setFile,
    photo,
    setPhoto,
    s3Key,
    setS3Key,
    toast,
    toastMessage,
    disabled,
    setImageUrl,
  } = props;

  const altUrl = placeholder;

  async function handleChange(event: any) {
    const fileImage = event.target.files[0];
    if (!fileImage) return;
    const photoUrl = URL.createObjectURL(fileImage);
    if (setPhoto) {
      setPhoto(photoUrl);
    }
    if (setFile) {
      setFile(fileImage);
    }
    if (s3Key) {
      await s3UploadFileImage(s3Key, photoUrl);
      if (toast) {
        toast.current.show({
          severity: "success",
          summary: toastMessage || "Image Uploaded Successfully",
          life: 3000,
        });
      }
    }
  }

  async function getS3Image(key: string) {
    const s3url = await s3GetUrl(key);
    if (setPhoto) {
      setPhoto(s3url);
    }
  }

  useEffect(() => {
    if (!photo && s3Key) {
      getS3Image(s3Key);
    }
  }, [photo, s3Key]);

  return (
    <div
      className={"image-uploader"}
      onClick={() => {
        if (disabled) return;

        const img = document.getElementById("imageUpload");
        img?.click();
      }}
    >
      <div className={"edit-icon"}>
        <PencilEdit width={28} height={28} />
      </div>

      <img
        src={photo || altUrl}
        alt={"business-logo"}
        style={{ width: "17rem", height: "auto" }}
        onError={e => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = altUrl;
        }}
      />
      <input
        id="imageUpload"
        type="file"
        accept="image/png, image/jpeg"
        onChange={handleChange}
        style={{ display: "none" }}
      ></input>
    </div>
  );
}
